export default "__VITE_ASSET__DGzSpFyN__"